import { useTranslation } from 'next-i18next'
import { useMemo } from 'react'

export default function (enumModel, namespace, path = '') {
  const { t } = useTranslation(namespace)

  return {
    sortAsc: useMemo(() => {
      if (!enumModel) return []

      return enumModel
        .map(({ id, name }) => ({ id, name, translatedName: t(`${path}${name}`, { ns: namespace }) }))
        .sort((a, b) => {
          if (a.translatedName < b.translatedName) {
            return -1
          }

          if (a.translatedName > b.translatedName) {
            return 1
          }

          return 0
        })
    })
  }
}
